<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :isShowApplyStateSelect="true"
    applyStateSelectLabel="审核状态"
    :is-show-administrator-select="isAdministrator"
    administrator-select-label="申请人员"
    :is-show-quick-time-tab="true"
    quick-time-tab-label="申请日期"
    :is-show-quick-time-tab-week="false"
    :is-show-quick-time-tab-last-thirty-day="false"
    :is-show-quick-time-tab-month="true"
    :is-show-quick-time-tab-last-month="true"
    :is-show-student-select="true"
    student-select-label="所属学员"
    :is-show-store-select="isAdministrator"
    :is-multiple-store="true"
    :has-private-store="true"
    store-select-label="申请门店"
    :push-list="RouteConfig.voucherAddApplyList.push"
    :query-list="queryList"
    :show-summary="false"
  >
    <v-column-time value="申请时间"/>
    <v-column-time v-if="currentState.timeLabel" :value="currentState.timeLabel" field="update_time"/>
    <v-column-admin label="申请者"/>
    <el-table-column v-if="isAdministrator" label="申请门店" prop="store_name"/>
    <v-column-student label="所属学员" link-page-id="student_id"/>
    <el-table-column label="代金券类型" prop="voucher_type_name"/>
    <el-table-column label="面额（元）">
      <template v-slot="{ row }">{{ row.amount_in_cents | toYuan }}</template>
    </el-table-column>
    <el-table-column label="唯一性" width="110">
      <template v-slot="{ row }">{{ row.is_unique === 1 ? '每人限领一张' : '可重复拥有' }}</template>
    </el-table-column>
    <el-table-column label="申请原因" prop="apply_remark" show-overflow-tooltip/>
    <el-table-column label="状态">
      <template v-slot="{ row }">
        <span v-for="state in findApplyState(row.apply_state)" :key="state.value">
          <el-tag :type="state.tagType" size="small">{{ state.name }}</el-tag>
        </span>
      </template>
    </el-table-column>

    <el-table-column width="210px" label="操作">
      <template v-slot="{ row }">
        <v-list-button :to="RouteConfig.voucherAddApplyDetail.to(row.id)" icon="view" name="查看"/>

        <v-list-button
          v-if="!isAdministrator && row.apply_state === applyStates.review.value"
          name="撤销"
          icon="undo"
          @click="handleRevoke(row)"
          :is-loading="isRevoking[row.id]"
          message="确定要撤销此申请吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`voucher-apply-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>申请时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>操作时间</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>申请者</span>
              <span>{{ v.administrator_nickname }}</span>
            </div>

            <div class="list-item-detail" v-if="isAdministrator">
              <span>申请门店</span>
              <span>{{ v.store_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>所属学员</span>
              <span>{{ v.student_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>代金券类型</span>
              <span>{{ v.voucher_type_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>面额（元）</span>
              <span>{{ v.amount_in_cents | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>唯一性</span>
              <span>{{ v.is_unique === 1 ? '每人限领一张' : '可重复拥有' }}</span>
            </div>

            <div class="list-item-detail">
              <span>申请原因</span>
              <span>{{ v.apply_remark }}</span>
            </div>

            <div class="list-item-detail">
              <span>状态</span>
              <span>
                <span v-for="state in findApplyState(v.apply_state)" :key="state.value">
                  <el-tag :type="state.tagType" size="small">{{ state.name }}</el-tag>
                </span>
              </span>
            </div>

            <div class="list-item-button">
              <v-list-button :to="RouteConfig.voucherAddApplyDetail.to(v.id)"/>

              <v-list-button
                v-if="!isAdministrator && v.apply_state === applyStates.review.value"
                name="撤销"
                icon="undo"
                @click="handleRevoke(v)"
                :is-loading="isRevoking[v.id]"
                message="确定要撤销此申请吗？"
                :is-last="true"
              />
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index, destroy } from '@/api/voucher-add-apply';
import { applyStates, findApplyState } from '@/enums/applyStates';

export default {
  name: RouteConfig.voucherAddApplyList.name,
  data: () => ({
    RouteConfig,
    applyStates,
    isLoading: false,
    isRevoking: {},
    count: 0,
    list: [],
    queryList: {
      is_asc: 0,
      apply_states: [applyStates.review.value],
      page: 1,
      size: 10,
    },
  }),
  computed: {
    ...mapGetters(['isAdministrator']),
    currentState() {
      const states = this.queryList.apply_states;
      if (states.length !== 1) return {};
      return findApplyState(states[0])[0] || {};
    },
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findApplyState,
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;
      getLegalQueryList(queryList, query);

      const params = { ...queryList };
      this.isLoading = true;
      const { isError, data } = await index(params);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleRevoke({ id, update_time }) {
      if (this.isRevoking[id]) return;
      if (!Number.isInteger(update_time) || update_time < 0) return this.$message.warning('缺少申请信息，无法撤销！');

      this.$set(this.isRevoking, id, true);
      const { isError } = await destroy(id, { update_time });
      this.$set(this.isRevoking, id, false);
      if (!isError) {
        this.$message.success('已撤销');
        this.load();
      }
    },
  },
};
</script>
